import { jsxs as i, jsx as s } from "react/jsx-runtime";
import t from "../../../../elements/link-wrapper/link-wrapper.js";
import e from "./mobile-featured-link.module.less.js";
const n = ({ title: a, url: o, icon: r }) => /* @__PURE__ */ i(t, { className: e.wrapper, url: o, children: [
  r && /* @__PURE__ */ s("span", { className: [e.icon, r].join(" ") }),
  /* @__PURE__ */ s("p", { className: [e.title, "body-base mb-0"].join(" "), children: a })
] });
export {
  n as default
};
